<template>
    <v-app>
        <v-container class="custom-container" :class="isLoggedIn ? '' : 'bg'" fluid>
            <v-row no-gutters class="px-0 mx-0">
                <v-col v-if="isLoggedIn" :cols="12">
                    <topbar />
                    <v-divider />
                </v-col>
            </v-row>
            <v-row class="pt-14 mx-0 px-0">
                <v-col v-if="isLoggedIn" cols="1" class="mx-0 px-0">
                    <sidebar />
                </v-col>
                <v-col :cols="12" class="mx-0 px-0">
                    <router-view :key="$route.path" />
                </v-col>
            </v-row>
        </v-container>
        <v-btn
            v-show="fab"
            v-scroll="onScroll"
            fab
            dark
            fixed
            bottom
            right
            color="black"
            @click="toTop"
        >
            <v-icon large>mdi-chevron-up</v-icon>
        </v-btn>
    </v-app>
</template>

<script>
    import Sidebar from '@/components/Sidebar'
    import Topbar from '@/components/Topbar'
    import jwtUtil from '@/utils/jwtUtil'

    export default {
        name: 'App',
        components: {
            Sidebar,
            Topbar
        },
        data: () => ({
            interval: null,
            fab: false
        }),
        computed: {
            isLoggedIn() {
                return this.$store.getters.isLoggedIn
            },
            drawer() {
                return this.$store.getters.getDrawer
            },
            jwtToken() {
                return this.$store.getters.getToken
            }
        },
        watch: {
            $route() {
                document.title = `Logistics - ${this.$route.name}`
            }
        },
        created() {
            if (this.isLoggedIn) {
                this.interval = setInterval(() => {
                    this.checkJwt()
                }, 1000)
            }
        },
        methods: {
            onScroll(e) {
                if (typeof window === 'undefined') return
                const top = window.pageYOffset || e.target.scrollTop || 0
                this.fab = top > 20
            },
            toTop() {
                this.$vuetify.goTo(0)
            },
            checkJwt() {
                if (jwtUtil.isJwtExpired(this.jwtToken)) {
                    this.$store.dispatch('logout').then(() => this.$router.push({ path: '/login' }))
                    clearInterval(this.interval)
                }
            }
        }
    }
</script>

<style>
    .bg {
        /* position: absolute; */
        background: url('assets/top-view-finance-business-elements.jpg'), #dddddf;
        background-size: cover;
        background-repeat: no-repeat;

        /* background: rgb(255,162,0);
        background: linear-gradient(90deg, rgba(255,162,0,1) 0%, rgba(240,240,242,1) 50%); */
        width: 100%;
        height: auto;
        min-height: 100%;
    }
    .custom-container {
        padding-bottom: 20vh;
        padding-top: 0px;
        padding-left: 0px;
        padding-right: 0px;
    }
</style>
